import { __decorate, __metadata } from "tslib";
import { MEDIA_PROPS_ACCESSOR, MEDIA_PROPS_EDITORDEF, MediaAssets } from '@common/media/shared';
import { UseRestraints } from '@core/shared/restraints';
import { CrudEndpoints, Default, EditorDefinition, Expose, IdItemModel, ItemModelDefinition, MinLength, Trim, ModelId } from '@core/shared/model';
import { CourseAttachmentRestraints } from './course-attachment.restraints';
let CourseAttachmentItem = /*#__PURE__*/(() => {
  let CourseAttachmentItem = class CourseAttachmentItem extends IdItemModel {};
  __decorate([Expose(), Trim(), MinLength(3), Default(''), __metadata("design:type", String)], CourseAttachmentItem.prototype, "name", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], CourseAttachmentItem.prototype, "courseId", void 0);
  CourseAttachmentItem = __decorate([EditorDefinition('admin', {
    name: true,
    [MEDIA_PROPS_ACCESSOR]: MEDIA_PROPS_EDITORDEF
  }), CrudEndpoints({
    admin: '/admin/courses/:courseId/attachments'
  }), UseRestraints(CourseAttachmentRestraints), ItemModelDefinition({
    texts: {
      item: 'Anhang',
      items: 'Anhänge',
      newItem: 'Neuen Anhang erstellen'
    }
  }), MediaAssets(['file']), ModelId("CourseAttachmentItem") // auto-generated by generate-model-ids
  ], CourseAttachmentItem);
  return CourseAttachmentItem;
})();
export { CourseAttachmentItem };